import React from 'react';
import { experiments } from '@physlab/core';
import { BrandMark, ExperimentGlyph, Icon } from './Icons.jsx';

export function TopBar({
  model,
  onSelectLab,
  presentation,
  onTogglePresentation,
  selfTest,
  repairs,
  onOpenDiagnostics,
  running,
}) {
  return (
    <header className="topbar">
      <div className="topbar-left">
        <a
          className="portal-return"
          href="/"
          title="返回 AI4U Classroom 主页"
        >
          <Icon name="arrowLeft" size={16} />
          <span>返回主页</span>
        </a>
        <div className="brand">
          <BrandMark size={44} />
          <div className="brand-copy">
            <div className="brand-name">
              PhysLab<span className="brand-dot">.</span>
            </div>
            <div className="brand-sub">物理仿真教学台</div>
          </div>
        </div>
      </div>

      <nav className="lab-tabs" aria-label="实验选择">
        {experiments.map((item, index) => (
          <button
            key={item.id}
            type="button"
            className={`lab-tab ${item.id === model.id ? 'active' : ''}`}
            onClick={() => onSelectLab(item.id)}
            aria-current={item.id === model.id ? 'page' : undefined}
          >
            <span className="lab-tab-index">{String(index + 1).padStart(2, '0')}</span>
            <span className="lab-tab-glyph">
              <ExperimentGlyph id={item.id} size={26} />
            </span>
            <span className="lab-tab-copy">
              <strong>{item.meta.shortTitle}</strong>
              <small>{item.meta.eyebrow.split(' ')[0]}</small>
            </span>
          </button>
        ))}
      </nav>

      <div className="top-actions">
        <div className={`run-indicator ${running ? 'is-running' : ''}`}>
          <span className="run-dot" />
          <span>{running ? '仿真运行中' : '已暂停'}</span>
        </div>
        <button
          type="button"
          className={`top-action ${selfTest && !selfTest.summary.ok ? 'has-alert' : ''}`}
          onClick={onOpenDiagnostics}
          title="查看守恒自检与自动修复日志"
        >
          <Icon name="shield" size={17} />
          <span className="top-action-label">自检</span>
          <span className={`mini-badge ${selfTest?.summary.ok ? 'ok' : 'warn'}`}>
            {selfTest ? selfTest.summary.label : '—'}
          </span>
          {repairs > 0 && <span className="repair-count">{repairs}</span>}
        </button>
        <button
          type="button"
          className={`top-action ${presentation ? 'active' : ''}`}
          onClick={onTogglePresentation}
          title="课堂演示模式（快捷键 P）"
        >
          <Icon name="maximize" size={17} />
          <span className="top-action-label">{presentation ? '退出演示' : '课堂模式'}</span>
        </button>
      </div>
    </header>
  );
}
